import React from 'react';
import { Box, Flex, Button } from '@kistech/kis-ui';
import { actions as adminsActions } from 'store/admins';
import { CreateNewUserSuccessProps } from '../types';
import { useActions } from 'hooks/useActions';
import { Grid, Typography as MuiTypography, Box as MuiBox } from '@mui/material';
import { useStyles } from '../styled';

export const CreateNewUserSuccess = (props: CreateNewUserSuccessProps) => {
  // ACTION CREATOR
  const { resetAction } = useActions({ resetAction: adminsActions.resetAction });

  const classes = useStyles();

  // SUCCESS CLICK
  const onSuccessClick = () => {
    // PROPS.ONCONFIRM AND RESET ACTION
    props.onConfirm();
    resetAction();
  };

  return (
    <Flex justify="center" flexOverride="1 1 0%" padding="0 0 11" margin="3 0 0">
      <Grid className={classes.createUserSuccessContainer}>
        <Box flexOverride="none" fullWidth>
          <MuiTypography className={classes.createUserSuccessHeader}>New User Created</MuiTypography>
        </Box>
        <Box flexOverride="none" fullWidth>
          <MuiTypography className={classes.createUserSuccessSubHeader}>
            You have successfully added a new user. An email has been sent containing their credentials.
          </MuiTypography>
        </Box>
        {/* BUTTON TO FIRE SUCCESS CLICK */}
        <MuiBox className={classes.createUserViewBox}>
          <Button size="large" onClick={onSuccessClick} className={classes.createUserViewButton}>
            View Users
          </Button>
        </MuiBox>
      </Grid>
    </Flex>
  );
};
